// extracted by mini-css-extract-plugin
module.exports = {"calendarmonth":"CalendarMonth_calendarmonth__8D9fC","is-past":"CalendarMonth_is-past__cJC2l"};